import React, { useState, useEffect } from 'react';
import { getFacturas, getFurgones } from '../services/api';

function Reportes() {
  const [facturas, setFacturas] = useState([]);
  const [furgones, setFurgones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({ fechaIni: '', fechaFin: '', estado: '', moneda: '', furgon: '' });
  const [resultados, setResultados] = useState([]);
  const [generado, setGenerado] = useState(false);

  useEffect(() => {
    const hoy = new Date().toISOString().split('T')[0];
    const primerDia = hoy.slice(0, 8) + '01';
    setFiltros(f => ({ ...f, fechaIni: primerDia, fechaFin: hoy }));
    Promise.all([
      getFacturas(1, 1000),
      getFurgones()
    ]).then(([facRes, furRes]) => {
      setFacturas(facRes.data.data || []);
      setFurgones(furRes.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const fmt = (monto, moneda) => {
    if (moneda === 'DOP') return `RD$${Number(monto).toLocaleString('es-DO', { minimumFractionDigits: 2 })}`;
    return `$${Number(monto).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  };

  const getTotal = (f) => f.detalles?.reduce((s, d) => s + d.total, 0) || 0;
  const getPagado = (f) => (f.pagos?.reduce((s, p) => s + p.monto, 0) || 0) + (f.deposito || 0);
  const getBalance = (f) => getTotal(f) - getPagado(f);

  const generar = () => {
    const res = facturas.filter(f => {
      const fecha = f.fechaCreacion?.split('T')[0];
      const matchFecha = (!filtros.fechaIni || fecha >= filtros.fechaIni) && (!filtros.fechaFin || fecha <= filtros.fechaFin);
      const matchEstado = !filtros.estado || f.estadoPago === filtros.estado;
      const matchMoneda = !filtros.moneda || f.moneda === filtros.moneda;
      const matchFurgon = !filtros.furgon || f.furgonNumero === filtros.furgon;
      return matchFecha && matchEstado && matchMoneda && matchFurgon && !f.anulada;
    });
    setResultados(res);
    setGenerado(true);
  };

  const totalFacturado = resultados.reduce((s, f) => s + getTotal(f), 0);
  const totalCobrado = resultados.reduce((s, f) => s + getPagado(f), 0);
  const totalBalance = resultados.reduce((s, f) => s + getBalance(f), 0);

  const badgeStyle = (estado) => {
    const map = { 'Pendiente': { bg: '#fef3c7', color: '#d97706' }, 'Abono Parcial': { bg: '#dbeafe', color: '#1d4ed8' }, 'Pagada': { bg: '#dcfce7', color: '#16a34a' } };
    const s = map[estado] || { bg: '#f1f5f9', color: '#64748b' };
    return { background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 };
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Cargando...</div>;

  return (
    <div>
      {/* Filtros */}
      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', marginBottom: 18, overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Filtros</h3>
        </div>
        <div style={{ padding: 22 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 16 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Fecha Inicio</label>
              <input type="date" value={filtros.fechaIni} onChange={e => setFiltros({ ...filtros, fechaIni: e.target.value })}
                style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Fecha Fin</label>
              <input type="date" value={filtros.fechaFin} onChange={e => setFiltros({ ...filtros, fechaFin: e.target.value })}
                style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Furgón</label>
              <select value={filtros.furgon} onChange={e => setFiltros({ ...filtros, furgon: e.target.value })}
                style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none' }}>
                <option value="">Todos los furgones</option>
                {furgones.map(f => (
                  <option key={f.id} value={f.numero}>Furgón #{f.numero}</option>
                ))}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Estado</label>
              <select value={filtros.estado} onChange={e => setFiltros({ ...filtros, estado: e.target.value })}
                style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none' }}>
                <option value="">Todos</option>
                <option>Pendiente</option><option>Abono Parcial</option><option>Pagada</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Moneda</label>
              <select value={filtros.moneda} onChange={e => setFiltros({ ...filtros, moneda: e.target.value })}
                style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none' }}>
                <option value="">Todas</option><option>USD</option><option>DOP</option>
              </select>
            </div>
          </div>
          <button onClick={generar} style={{ padding: '10px 24px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
            📊 Generar Reporte
          </button>
        </div>
      </div>

      {/* Resultados */}
      {generado && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 18 }}>
            {[
              { label: 'Total Facturado', value: `$${totalFacturado.toLocaleString('en-US', { minimumFractionDigits: 2 })}`, color: '#0d2461' },
{ label: 'Total Cobrado', value: `$${totalCobrado.toLocaleString('en-US', { minimumFractionDigits: 2 })}`, color: '#16a34a' },
{ label: 'Balance Pendiente', value: `$${totalBalance.toLocaleString('en-US', { minimumFractionDigits: 2 })}`, color: '#cc0000' },
            ].map(({ label, value, color }) => (
              <div key={label} style={{ background: 'white', borderRadius: 12, padding: 20, border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500, textTransform: 'uppercase' }}>{label}</div>
                <div style={{ fontSize: 22, fontWeight: 700, color, margin: '6px 0' }}>{value}</div>
              </div>
            ))}
          </div>

          {filtros.furgon && (
            <div style={{ background: '#dbeafe', borderRadius: 10, padding: '12px 18px', marginBottom: 16, fontSize: 14, color: '#0d2461', fontWeight: 600 }}>
              🚛 Reporte del Furgón #{filtros.furgon} — {resultados.length} facturas
            </div>
          )}

          <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
            <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
              <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Resultados ({resultados.length})</h3>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Factura', 'Fecha', 'Furgón', 'Remitente', 'Destinatario', 'Total', 'Pagado', 'Balance', 'Estado'].map(h => (
                      <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {resultados.length === 0 ? (
                    <tr><td colSpan={9} style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>Sin resultados</td></tr>
                  ) : resultados.map(f => (
                    <tr key={f.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: '13px 16px', fontFamily: 'monospace', fontWeight: 600, fontSize: 13 }}>{f.numero}</td>
                      <td style={{ padding: '13px 16px', fontSize: 13 }}>{new Date(f.fechaCreacion).toLocaleDateString('es-DO')}</td>
                      <td style={{ padding: '13px 16px' }}><span style={{ background: '#dbeafe', color: '#0d2461', padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 }}>#{f.furgonNumero}</span></td>
                      <td style={{ padding: '13px 16px', fontSize: 14 }}>{f.remNombre}</td>
                      <td style={{ padding: '13px 16px', fontSize: 14 }}>{f.desNombre}</td>
                      <td style={{ padding: '13px 16px', fontSize: 14, fontWeight: 600 }}>{fmt(getTotal(f), f.moneda)}</td>
                      <td style={{ padding: '13px 16px', fontSize: 14, color: '#16a34a', fontWeight: 600 }}>{fmt(getPagado(f), f.moneda)}</td>
                      <td style={{ padding: '13px 16px', fontSize: 14, color: getBalance(f) > 0 ? '#cc0000' : '#16a34a', fontWeight: 600 }}>{fmt(getBalance(f), f.moneda)}</td>
                      <td style={{ padding: '13px 16px' }}><span style={badgeStyle(f.estadoPago)}>{f.estadoPago}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Reportes;